import { Buffer } from "buffer";

import { v4 as uuid } from "uuid";

import amazonS3 from "../amazonS3";

export interface UploadBase64ImageOptions {
  fileName?: string;
  pathPrefix?: string;
  extension?: string;
}

export const uploadBase64ImageToS3 = async (
  base64: string,
  extension = "png",
  options?: UploadBase64ImageOptions
): Promise<string> => {
  if (!base64) throw new Error("Base64 payload must be provided");

  const normalizedExtension = (options?.extension || extension || "png")
    .replace(/^\./, "")
    .toLowerCase();

  const fileBaseName = options?.fileName || `${options?.pathPrefix || "image"}-${uuid()}`;

  const buffer = Buffer.from(base64, "base64");

  return amazonS3.uploadPhoto(fileBaseName, buffer, normalizedExtension);
};
